<template>
    <tooltip-icon
            :color="color"
            v-bind="$attrs"
            v-on="$listeners"
            :tooltip="tooltip"
    >
        mdi-eye-outline
    </tooltip-icon>
</template>

<script>
    import TooltipIcon from './TooltipIcon'

    const
        defaultColor = 'blue lighten-1',
        defaultTooltip = 'pages.all.actions.show'

    export default {
        name: "ShowIcon",
        inheritAttrs: false,
        components: {
            TooltipIcon
        },
        props: {
            color: {
                required: false,
                type: String,
                default: defaultColor,
            },
            tooltip: {
                required: false,
                default: defaultTooltip,
            },
        },
    }
</script>
